import React from "react";
import { CSVLink } from "react-csv";

function CSVButton({ CSVData, buttonText }) {
  return <CSVLink data={CSVData}>{buttonText || "Baixar em CSV"}</CSVLink>;
}

export default CSVButton;
